import { ButtonSize } from "@components/button/button-constants";
import ComboboxGeneric from "@components/combobox/generic-combobox";

import useCareerRoleOptions from "./use-career-role-options";

// A person's place on the career ladder: one role, or none. Picking one
// saves straight away, ending the role they held before.
const MemberCareerRoleSelect = ({
  organizationId,
  userId,
  currentRole,
  disabled,
}: {
  organizationId: number;
  userId: number;
  currentRole: { id: number; title: string } | null;
  disabled?: boolean;
}) => {
  const { options, loading, isSaving, assignRole } =
    useCareerRoleOptions(organizationId);
  const selected = currentRole
    ? (options.find((option) => option.value === currentRole.id) ?? {
        label: currentRole.title,
        value: currentRole.id,
      })
    : null;
  // The save only ends the roles it names, so a swap names the one held.
  const endRoleIds = currentRole ? [currentRole.id] : [];

  return (
    <ComboboxGeneric
      aria-label="Member career role select"
      // The same height as the dialog's other fields.
      buttonProps={{ size: ButtonSize.large }}
      className="w-48"
      disabled={disabled || isSaving}
      loading={loading}
      options={options}
      placeholder="No role"
      searchPlaceholder="Search roles..."
      // The button names the role alone; the menu adds its track.
      value={selected && { label: selected.label, value: selected.value }}
      clearable={!!currentRole}
      onClearValue={() => assignRole(userId, null, endRoleIds)}
      onChangeValue={(option) => {
        if (option.value !== currentRole?.id) {
          assignRole(userId, option.value, endRoleIds);
        }
      }}
    />
  );
};

export default MemberCareerRoleSelect;
